import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { useStyles } from './styles'

export type SectionProps = {
  icon: ReactNode
  title: string
  subtitle?: string
  children: ReactNode
  scrollable?: boolean
  minHeaderHeight?: number | string
}

function Section({ icon, title, subtitle, children, scrollable, minHeaderHeight }: SectionProps) {
  const styles = useStyles({ minHeaderHeight })

  return (
    <CustomPaper elevation={0} sx={scrollable ? styles.scrollableContainer : styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.icon}>{icon}</Box>

        <Box sx={styles.titles}>
          <Typography sx={styles.title}>{title}</Typography>

          {!!subtitle && <Typography sx={styles.subtitle}>{subtitle}</Typography>}
        </Box>
      </Box>

      <Box sx={scrollable ? styles.scrollableContent : styles.content}>{children}</Box>
    </CustomPaper>
  )
}

export { Section }
